// ----------------------------------------------------------------------------
// Nombre del Programa : Main
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase donde se configuran todas las rutas y el menu de la pagina
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import "./Main.scss";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Home } from "../home/Home";
import { NavBar } from "../../components/nav-bar/NavBar";
import { Col, Container, Row } from "react-bootstrap";
import { Footer } from "../../components/footer/Footer";
import { SideBar } from "../../components/side-bar/SideBar";
import { SolicitudComunicados } from "../solicitud-comunicados/SolicitudComunicados";
import { DetalleSolicitudComunicado } from "../solicitud-comunicados/detalle-solicitudcomunicado/DetalleSolicitudComunicado";
import { Comunicados } from "../comunicados/Comunicados";
import { Enlaces } from "../enlaces/Enlaces";
import { Analiticos } from "../analiticos/Analiticos";
import { Usuarios } from "../usuarios/Usuarios";
import { RolesPermisos } from "../roles-y-permisos/RolesPermisos";
import { DetalleComunicado } from "../comunicados/detalle-comunicado/DetalleComunicado";
import { VistaComunicado } from "../comunicados/vista-comunicado/VistaComunicado";
import { DetalleEnlace } from "../detalle-enlace/DetalleEnlace";
import { AgregarUsuario } from "../usuarios/agregar-usuario/AgregarUsuario";
import { useSelector,useDispatch } from "react-redux";
import { DetalleRol } from "../roles-y-permisos/detalle-rol/DetalleRol";
import { Loader } from "../../components/loader/Loader";
import { AuthInterceptor } from "../../components/auth-interceptor/AuthInterceptor";
import { SobreNosotros } from "../sobre-nosotros/SobreNosotros";
import { AvisoPrivacidad } from "../aviso-privacidad/AvisoPrivacidad";
import { ScrollToTop } from "../../components/scroll-to-top/ScrollToTop";
import StatusAlert from "react-status-alert";
import { PaginaError } from "../pagina-error/PaginaError";
import { Configuraciones } from "../Configuraciones/Configuraciones";
import { ConfiguracionesNosotros } from "../Configuraciones/configuracion-nosotros/ConfiguracionesNosotros";
import { ConfiguracionesPrivacidad } from "../Configuraciones/configuracion-privacidad/ConfiguracionesPrivacidad";
import { Buscador } from "../buscador/Buscador";
import { DetalleBanner } from "../banners/DetalleBanner/DetalleBanner";
import { Banners } from "../banners/Banners";
import { Popups } from "../popups/Popups";
import { DetallePopup } from "../popups/DetallePopup/DetallePopup";
import { Activepopups } from "../popups/ActivePopups";
import { getToken } from '../../Utilidades/session';
import { loginSetup } from '../../Utilidades/interceptorLogin';
import { useEffect,useState } from 'react';

export const Main = () => {
  const iniciado = useSelector((state: any) => state.authUser.loggedIn);
  const cargando = useSelector((state: any) => state.app.pendingRequests > 0);
  //Modificacion: Marca de Inicio WII C-24-1229-24
  const pantallas = useSelector((state: any) => state.authUser.pantallas);

  var claseloggedin = pantallas.length > 0 ? "logged-in" : "logged-insm";
  //Modificacion: Marca de Fin WII C-24-1229-24

  const dispatch = useDispatch();
  const [validoSesion, setvalidoSesion] = useState<boolean>(false);

  useEffect(() => {
  const loadData = async () => {
    let token = getToken()
    if(token && !iniciado){
      await loginSetup(token,setvalidoSesion,dispatch);
    }
  };
  loadData();
  }, []);

  return (
    <>
      {cargando ? <Loader></Loader> : null}
      <StatusAlert />
      <ScrollToTop></ScrollToTop>
      <Router>
        <NavBar></NavBar>
        <Container className="p-0 d-flex" fluid>
          <AuthInterceptor></AuthInterceptor>

          {iniciado ? <SideBar></SideBar> : null}
          <Row className={"main-content " + (iniciado ? claseloggedin : "")}>
            <Col className="pb-3">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route
                  path="/solicitud-comunicados"
                  element={<SolicitudComunicados />}
                />
                <Route path="/comunicados" element={<Comunicados />} />
                <Route path="/enlaces" element={<Enlaces />} />
                <Route path="/analiticos" element={<Analiticos />} />
                <Route path="/usuarios" element={<Usuarios />} />
                <Route path="/roles-permisos" element={<RolesPermisos />} />
                <Route
                  path="/comunicados/comunicado/:comunicadoId"
                  element={<DetalleComunicado />}
                />

                <Route path="/banners" element={<Banners />} />
                <Route
                  path="/banners/:comunicadoId"
                  element={<DetalleBanner />}
                />

                <Route path="/popups" element={<Popups />} />
                <Route
                  path="/popups/:comunicadoId"
                  element={<DetallePopup />}
                />

                <Route
                  path="/vista-comunicado/:comunicadoId"
                  element={<VistaComunicado />}
                />
                <Route path="/enlaces/enlace" element={<DetalleEnlace />} />
                <Route
                  path="/usuarios/agregar-usuario"
                  element={<AgregarUsuario />}
                />
                <Route
                  path="/roles-permisos/detalle-rol/:id"
                  element={<DetalleRol />}
                />
                <Route
                  path="/solicitud-comunicados/detalle-solicitud/:id"
                  element={<DetalleSolicitudComunicado />}
                />
                <Route
                  path="/solicitar-comunicado"
                  element={<DetalleSolicitudComunicado />}
                />
                <Route path="/configuraciones" element={<Configuraciones />} />
                {/*Modificacion: Marca de Inicio WII C-24-1229-24*/}
                <Route
                  path="/politica-configuracion"
                  element={<ConfiguracionesPrivacidad />}
                />
                <Route
                  path="/nosotros-configuracion"
                  element={<ConfiguracionesNosotros />}
                />
                <Route path="/sobre-nosotros" element={<SobreNosotros />} />
                <Route path="/aviso-privacidad" element={<AvisoPrivacidad />} />
                <Route path="/pagina-error" element={<PaginaError />} />
                <Route path="/buscador" element={<Buscador />} />
                {/*Modificacion: Marca de Fin WII C-24-1229-24*/}
              </Routes>
            </Col>
          </Row>
        </Container>
        <Footer></Footer>
      </Router>
    </>
  );
};
